// extracted by mini-css-extract-plugin
module.exports = {"card":"CardAction_card_2SbE4","content":"CardAction_content_2IY60","label":"CardAction_label_aEhr4"};